import React from "react";
import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../utils/commonUtils";

const MultipleImageInput = ({ selectedImages, setSelectedImages }) => {
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 50 * 1024;
    const validImages = [];
    for (const file of files) {
      if (file.size > maxSize) {
        Swal.fire({
          icon: "error",
          text: `Each image must be less than or equal to 50KB.`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          ...swalAlertPopProps,
        });
        continue;
      }

      validImages.push({
        url: URL.createObjectURL(file),
        file: file,
      });
    }

    setSelectedImages([...selectedImages, ...validImages]);
  };

  const removeImage = (index) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
  };

  return (
    <Box>
      <input
        id="multi-image-upload"
        type="file"
        multiple
        accept="image/*"
        hidden
        onChange={handleImageChange}
      />
      <Box
        component="label"
        htmlFor="multi-image-upload"
        sx={{
          border: "1px solid #01008B",
          borderRadius: "5px",
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "80%",
          cursor: "pointer",
          // color: "#0D1A80",
          fontWeight: 500,
          mb: 2,
        }}
      >
        <CameraAltOutlinedIcon fontSize="small" />
        <Typography sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}>
          ATTACH IMAGE
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: { xs: "12px", sm: "13px", md: "15px" },
          fontWeight: 500,
          color: "red",
        }}
      >
        Note: Image size must be less than or equal to 50KB
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        {selectedImages.map((image, index) => (
          <Box
            key={index}
            sx={{ position: "relative", width: 100, height: 100 }}
          >
            <img
              src={image.url}
              alt={`Preview ${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            />
            <IconButton
              size="small"
              onClick={() => removeImage(index)}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                color: "#fff",
                width: 20,
                height: 20,
                p: 0.5,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.7)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MultipleImageInput;
